import { Box } from '@mui/material';

import { TimeSeriesChartDesktop } from '../time-series-chart-desktop/TimeSeriesChartDesktop';

export type TimeSeriesChartPopupProps = {
  'data-qa-element-id'?: string;
};

export default function TimeSeriesChartPopup({ 'data-qa-element-id': dataQaElementId }: TimeSeriesChartPopupProps) {
  return (
    <Box sx={{ display: 'flex', width: 1, height: 1, minHeight: 0 }} data-qa-element-id={dataQaElementId}>
      <TimeSeriesChartDesktop />
    </Box>
  );
}
